import { Component } from '@angular/core';
import { FeedbackSearch } from "../../../../core/models/FeedbackSearch";
import { LogHelper } from "../../../../core/helpers/log.helper";
import { FeedbackService } from "../../../../core/services/feedback.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-patient-feedback',
  templateUrl: './patient-feedback.component.html',
  styleUrls: ['./patient-feedback.component.scss']
})
export class PatientFeedbackComponent {
  feedback: FeedbackSearch = new FeedbackSearch();
  searchTerm: string = null;
  country: string = null;
  orderBy = 0;
  subscription: Subscription;

  constructor(private _feedbackService: FeedbackService) { }

  updateFilter(searchTerm: string, country: string, orderBy: number = 0) {
    this.searchTerm = searchTerm === '' ? null : searchTerm;
    this.country = country === '' ? null : country;
    this.orderBy = orderBy;
  }

  loadFeedback(page: number = 1, country: string = null, searchTerm: string = null, orderBy: number = 0): void {
    if (this.subscription !== undefined && this.subscription !== null && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }

    this.subscription = this._feedbackService.retrieveFeedback(searchTerm, country, page ?? 1, orderBy).subscribe({
        next: (rsp) => {
          this.feedback = rsp;
        },
        error: (err) => {
          LogHelper.log(err);
        }
      });
  }
}
